import { useCallback } from "react";
import { toast } from "@/components/podkit/toasts/use-toast";
import type { Session } from "@/components/ai/session/session-model";

export const useSessionActions = (session: Session) => {
    const copySessionId = useCallback(async () => {
        await navigator.clipboard.writeText(session.id);
        toast({ title: "Session ID copied to clipboard" });
    }, [session.id]);

    return {
        copySessionId,
    };
};
